import React, { useState, useMemo } from 'react';
import style from './loyaltyCopy.module.scss';
import LoyaltyOffers from './loyaltyOffersCopy';
import LoyaltySignIn from './loyaltySignInCopy';
import cn from 'classnames';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import LoyaltyKeyboard from './loyaltyKeyboardCopy';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import { flowType } from '../../utility/userInfo';
import LoyaltyLightImg from '@assets/images/loyaltyLight.png';
import LoyaltyImg from '@assets/images/loyalty.png';
import LoyaltyWelcomeSignedInScreen  from './LoyaltyWelcomeSignedInScreen';
import { TouchableButton, TouchableBack } from '@components/common/Touchable'
import PropTypes from "prop-types";


const Loyalty = ({
  loyaltyInfo,
  setPaymentFlowTypeLoyoltyBack,
  handleLoyaltyNotNow,
  handleLoyaltySignIn,
  loyaltyType,
  loyaltyMethod,
  handleLoyaltySubmit,
  getLoyaltyOffers,
  loyaltyOffers,
  handleApplyOffer,
  joinMethod,
  openLoyaltyKeyboard,
  countryCode,
  handleBackButton,
  groupedLoyaltyOffers,
  accountLookup,
  deleteLoyalty,
  handleCountryCodeChange,
  isConfirmStageSplit,
  suppressOfferOnSplitByPerson,
  ShowLandscapeMode,
  serverAppTheme,
  seat,
  handleLoyaltyInfo,
  setLoyaltyType,
  setErrorPopUp,
  ...props
}) => {
  const [joinClicked, setJoinClicked] = useState(false);
  const [alreadyMem, setAlreadyMem] = useState(true);
  const [isDeleteLoyalty, setIsDeleteLoyalty] = useState(false);
  let storeImage = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth'), ""));
  const isServerApp = flowType() === 'serverApp';
  const getTheme = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')).serverAppTheme);
  const isSpeedOrder = getObjectValue(() => (props.seat?.sourceType === 11), false);
  const isOffPremiseOrder = getObjectValue(() => ([6, 7, 8].includes(props.seat?.sourceType)), false);

  const isCallCenter = getObjectValue(
    () => isServerApp && [2].includes(props.deviceInfo.deviceGroup.startMode),
    false,
  );
  const themeProperties = useMemo(() => {
    try {
      return JSON.parse(window.sessionStorage.getItem("themeProperties")) || {};
    } catch {
      return {};
    }
  }, []);

  const nameMap = {
    phone: 'PhoneNumber',
    type: 'AccountNumber',
    email: 'Email',
  };

  const placeholderMap = {
    phone: LABEL().LS_PHONE,
    type: LABEL().LS_ACCOUNT,
    email: LABEL().LS_EMAIL,
  };

  const getName = () => nameMap[joinMethod] || joinMethod;
  const getPlaceHolder = () => placeholderMap[joinMethod] || joinMethod;

  const { lookupMethods, signUpMethods } = loyaltyInfo;
  const valid = ['swipe', 'scan'];


  const loyaltyAlreadyAMember = () => {
    if (lookupMethods?.length === 1 && lookupMethods?.[0] === '') {
      return true;
    } else if ((valid.includes(lookupMethods) && lookupMethods?.length === 2)) {
      return true;
    } else if (lookupMethods?.includes('swipe') && lookupMethods?.length === 1) {
      return true;
    } else if (lookupMethods?.includes('scan') && lookupMethods?.length === 1) {
      return true;
    }
    return false;
  };

  const loyaltyJoinNow = () => {
    if (signUpMethods?.length === 1 && signUpMethods?.[0] === '') {
      return true;
    } else if ((valid.includes(signUpMethods) && signUpMethods?.length === 2)) {
      return true;
    } else if (signUpMethods?.includes('swipe') && signUpMethods?.length === 1) {
      return true;
    } else if (signUpMethods?.includes('scan') && signUpMethods?.length === 1) {
      return true;
    }
    return false;
  };

  const joinLabel = useMemo(() => LABEL().LS_JOIN_NOW, []);
  const alreadyMemberLabel = useMemo(() => LABEL().LS_ALREADY_A_MEMBER, []);
  const notNowLabel = useMemo(() => LABEL().LS_NOT_NOW, []);
  const joinMessage = useMemo(() => CUSTOM_MESSAGES().LOYALTY_JOIN_MESSAGE, []);

  const LoyaltyWelcomeScreen = () => {
    return (
      <div className={cn('col-12 p-0 h-97 position-relative')}>
        {!ShowLandscapeMode &&
          <div className="w-100 pt-2 pb-1 h-20">
            {(themeProperties?.loyaltyImageUrl?.length > 0) ?
              <img src={themeProperties?.loyaltyImageUrl} alt=""
                loading="lazy"
                className={cn('w-100 h-100')} style={{ objectFit: 'cover' }} />
              :
              (getTheme === '2') ? <img src={LoyaltyLightImg} loading="lazy"
                style={{ width: '100%', objectFit: 'cover' }} className='h-100' alt='loyaltyLightImg' /> : <img src={LoyaltyImg} style={{ width: '100%', objectFit: 'cover' }}
                  loading="lazy"
                  className='h-100' alt='loyaltyImg' />}
          </div>}

        <div className={cn('row p-2 justify-content-center', ShowLandscapeMode ? 'h-50 align-items-end m-auto col-8' : 'h-64 mx-0')}>
          {!ShowLandscapeMode &&
            <div className="col-12 px-0 py-2 text-center fs_24 fw-700">
              {" "}
              {joinClicked
                ? LABEL().LS_SIGN_UP_TO_LOYALTY
                : alreadyMem
                  ? LABEL().LS_SIGN_IN_TO_LOYALTY
                  : ""}
            </div>}
          <div className={cn("fw-400 fs_32 p-1 text-center")} style={{ color: serverAppTheme?.primary_text }}>{joinMessage}</div>
        </div>

        <div className={cn("w-100 d-flex align-items-end position-absolute", ShowLandscapeMode ? (showCheckSeat()? 'py-3 h-55' : 'pt-3 h-55') : 'h-20 pt-3')}>
          <div className={cn('pt-2', ShowLandscapeMode ? 'w-60 mx-auto' : 'w-100')}>
            <div className={cn('d-flex justify-content-between', loyaltyJoinNow() && 'pb-1')}>
              {!loyaltyJoinNow() &&
                <TouchableButton type="button" disabled={loyaltyJoinNow()} className={cn(loyaltyAlreadyAMember() ? 'w-100' : 'w-50 mr-2', 'btn70 mb-2 fw-600 btn-ripple fs_28 od-primary-btn-bg-color od-primary-btn-font-color', style.loyalty_btn, ShowLandscapeMode && style.btnSize)} onClick={(event) => { event.preventDefault(); handleLoyaltySignIn('signUp'); setJoinClicked(true); setAlreadyMem(false) }} rippleEffect={true}>
                  {joinLabel}
                </TouchableButton>}
              {!loyaltyAlreadyAMember() &&
                <TouchableButton type="button" disabled={loyaltyAlreadyAMember()} className={cn(loyaltyJoinNow() ? 'w-100' : 'w-50', 'pl-2 pr-2 btn70 fw-600 btn-ripple fs_28 od-primary-btn-bg-color od-primary-btn-font-color', style.loyalty_btn, ShowLandscapeMode && style.btnSize)} onClick={(event) => { event.preventDefault(); handleLoyaltySignIn('signIn'); setJoinClicked(false); setAlreadyMem(true) }} rippleEffect={true}>
                  {alreadyMemberLabel}
                </TouchableButton>
              }
            </div>
            <div className={cn(loyaltyJoinNow() && 'pt-1')}>
              <TouchableButton
                type="button"
                className={cn('w-100 btn70 fw-600 btn-ripple fs_28 od-primary-btn-bg-color od-primary-btn-font-color', style.loyalty_btn, ShowLandscapeMode && style.btnSize, !loyaltyJoinNow() && 'mr-2',
                  loyaltyAlreadyAMember() && 'w-100')}
                onClick={(event) => { event.preventDefault(); handleLoyaltyNotNow(false) }}
                rippleEffect={true}
              >
                {notNowLabel}
              </TouchableButton>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const LoyaltySignUpConfirmation = () => {
    return (
      <div className="h-100 w-100 position-relative">
          {(loyaltyInfo.signUpImageUrl || loyaltyInfo.imageUrl) ? (
            <div className="w-100 py-1 h-20 pt-2 pb-1">
            <img
                loading="lazy"
                src={loyaltyInfo.signUpImageUrl || loyaltyInfo.imageUrl}
                alt=""
                style={{ width: "100%", height: "100%" }}
              />{" "}
            </div>
          ) : (
            <>
              {" "}
              {storeImage.imageUrl && (
                <div className="col-12 h-25 px-0 pt-2">
                  <div className="col-12 px-0 h-100">
                    <img
                        loading="lazy"
                      src={storeImage.imageUrl}
                      alt=""
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                </div>
              )}
            </>
          )}
          <div
            className={cn(`col-12 fs-32 h-65 fs_32 fw-600 justify-content-center align-items-center mx-0 row text-center`)}
            style={{
              color: serverAppTheme?.primary_text
            }}
          >
            {LABEL().LS_SIGN_UP_SUCCESS_TEXT}
          </div>
          <div
            className="w-100 text-center align-self-end position-absolute d-flex align-items-end"
            style={{ bottom: '0' }}
          >
            <button
              type="button"
              className="btn rounded btn-ripple btn68 w-100 od-primary-btn-bg-color od-primary-btn-font-color"
              onClick={() => setLoyaltyType(3)}
            >
              <div
                className={cn("fs_28 fw-600")}
              >
                {LABEL().CONTINUE}
              </div>
            </button>
          </div>
      </div>
    )
  }

  const handleLoyaltyFlow = (type) => {
    switch (type) {
      case 1: return <LoyaltyWelcomeScreen />;
      case 2: return <LoyaltySignIn loyaltyMethod={loyaltyMethod} loyaltyInfo={loyaltyInfo} openLoyaltyKeyboard={openLoyaltyKeyboard} storeImage={storeImage} serverAppTheme={serverAppTheme} joinClicked={joinClicked} alreadyMem={alreadyMem} themeProperties={themeProperties} isLandScape={ShowLandscapeMode} showCheckSeat={showCheckSeat}/>;
      case 3: return <LoyaltyOffers deleteLoyalty={deleteLoyalty} accountLookup={accountLookup} loyaltyType={loyaltyType} groupedLoyaltyOffer={groupedLoyaltyOffers} loyaltyInfo={loyaltyInfo} handleLoyaltyNotNow={handleLoyaltyNotNow} getLoyaltyOffers={getLoyaltyOffers} loyaltyRes={loyaltyOffers} handleApplyOffer={handleApplyOffer} isConfirmStageSplit={isConfirmStageSplit} suppressOfferOnSplitByPerson={suppressOfferOnSplitByPerson} storeImage={storeImage} handleBackButton={handleBackButton} serverAppTheme={serverAppTheme} isLandScape={ShowLandscapeMode} showCheckSeat={showCheckSeat} />;
      case 4: return <LoyaltyKeyboard countryCode={countryCode} joinMethod={joinMethod} handleLoyaltySubmit={handleLoyaltySubmit} name={getName()} placeHolder={getPlaceHolder()} handleBackButton={handleBackButton} handleCountryCodeChange={handleCountryCodeChange} loyaltyInfo={loyaltyInfo} serverAppTheme={serverAppTheme} loyaltyMethod={loyaltyMethod} getTheme={getTheme} handleLoyaltyInfo={handleLoyaltyInfo} themeProperties={themeProperties} setErrorPopUp={setErrorPopUp} isLandScape={ShowLandscapeMode} isSpeedOrder={isSpeedOrder} isCallCenter={isCallCenter} isOffPremiseOrder={isOffPremiseOrder}/>;
      case 5: return <LoyaltyOffers deleteLoyalty={deleteLoyalty} loyaltyType={loyaltyType} groupedLoyaltyOffer={groupedLoyaltyOffers} loyaltyInfo={loyaltyInfo} handleLoyaltyNotNow={handleLoyaltyNotNow} getLoyaltyOffers={getLoyaltyOffers} loyaltyRes={loyaltyOffers} handleApplyOffer={handleApplyOffer} isConfirmStageSplit={isConfirmStageSplit} suppressOfferOnSplitByPerson={suppressOfferOnSplitByPerson} storeImage={storeImage} handleBackButton={handleBackButton} serverAppTheme={serverAppTheme} isLandScape={ShowLandscapeMode}/>;
      case 6: return <LoyaltyWelcomeSignedInScreen deleteLoyalty={deleteLoyalty} loyaltyType={loyaltyType} loyaltyInfo={loyaltyInfo} handleLoyaltyNotNow={handleLoyaltyNotNow} storeImage={storeImage} serverAppTheme={serverAppTheme} isDeleteLoyalty={isDeleteLoyalty} setIsDeleteLoyalty={setIsDeleteLoyalty} isServerApp={isServerApp}/>
      case 7: return <LoyaltySignUpConfirmation />
      default: return <div />;
    }
  };

  const showCheckSeat = () => {
    if (!["1", "3"].includes(urlSearchParams('ticketSplitTypeId'))) {
      if (!["29", "30"].includes((urlSearchParams("screenType"))) && !isSpeedOrder && !isCallCenter && !isOffPremiseOrder) {
        return true;
      }
    } else {
      return false;
    }
  };

  const moreSeats = useMemo(() => {
    const checkSeats = props?.checkAndSeats?.seats?.map(item => {
      if (item?.name === null) {
        return `${item?.number}`;
      } else {
        const truncatedName = item?.name?.length > 4 ? item?.name?.substring(0, 4) + '...' : item?.name;
        return `${item?.number}(${truncatedName})`;
      }
    });
    return checkSeats?.join(',');
  }, [props?.checkAndSeats?.seats])

  return (
    <>
      <div className="w-100" style={{ height: "4%" }}>
        {![1, 3, 5, 7].includes(loyaltyType) &&
          <div
            className="d-flex position-fixed rounded align-items-center justify-content-center"
            style={{
              width: "2rem",
              height: "2rem",
              zIndex: 1000,
              backgroundColor: serverAppTheme.iconcolor_bg_box,
              top: ShowLandscapeMode && '18px',
              left: ShowLandscapeMode && '1rem'
            }}
          >
            <TouchableBack
              role="presentation"
              fill={serverAppTheme?.iconcolor}
              alt="back"
              onClick={(e) => {
                e.preventDefault();
                handleBackButton().url();
              }}
            />
          </div>
        }
          <div className={cn("col-12 d-flex fs_20 fw-600", [1, 3, 5, 7].includes(loyaltyType) ? 'pl-10 pr-50' : 'px-50')}
          style={{top: ShowLandscapeMode && '-4px',
          }}>
            <div className="col-6 px-0 text-left">
              {LABEL().TABLE}{" "}
              {(seat?.stationName?.length > 8
                ? seat?.stationName?.substring(0, 9) + "..."
                :seat?.stationName) ||
                (seat?.name?.length > 8
                  ? seat?.name?.substring(0, 9) + "..."
                  : seat?.name) ||
                seat?.stationNumber}
            </div>
            <div className="col-6 px-0 text-right">#{seat?.number}</div>
          </div>
      </div>
      {showCheckSeat() &&
        <div className={cn('col-12 px-0 h-5', ShowLandscapeMode ? 'mt-3' : 'pt-2')}>
          <div className={cn('col-12 fs_12 fs-12 fw-400 d-flex justify-content-between h-100 rounded align-items-center', ShowLandscapeMode ? 'pb-12' : '')} style={{ background: serverAppTheme?.checkDetail_tabs }}>
            <div className='col-6 h-50 text-left p-0'>
              Check {(props?.checkAndSeats?.stage?.name ? `${props?.checkAndSeats?.stage?.number}(${props?.checkAndSeats?.stage?.name?.substring(0, 4) + "..."})` : props?.checkAndSeats?.stage?.number)}
            </div>
            <div className={cn('col-6 h-50 text-right pr-0', style.scrollableText)}>
              Seat {moreSeats}
            </div>
          </div>
        </div>
      }
      <div className={cn(showCheckSeat() ? 'h-90' : 'h-96')}>{handleLoyaltyFlow(loyaltyType)}</div>
    </>
  );
};

Loyalty.propTypes = {
  loyaltyInfo: PropTypes.object,
  setPaymentFlowTypeLoyoltyBack: PropTypes.func,
  handleLoyaltyNotNow: PropTypes.func,
  handleLoyaltySignIn: PropTypes.func,
  loyaltyType: PropTypes.number,
  loyaltyMethod: PropTypes.string,
  handleLoyaltySubmit: PropTypes.func,
  getLoyaltyOffers: PropTypes.func,
  loyaltyOffers: PropTypes.object,
  handleApplyOffer: PropTypes.func,
  joinMethod: PropTypes.string,
  openLoyaltyKeyboard: PropTypes.func,
  countryCode: PropTypes.string,
  handleBackButton: PropTypes.func,
  groupedLoyaltyOffers: PropTypes.array,
  accountLookup: PropTypes.func,
  deleteLoyalty: PropTypes.func,
  handleCountryCodeChange: PropTypes.func,
  isConfirmStageSplit: PropTypes.bool,
  suppressOfferOnSplitByPerson: PropTypes.bool,
  ShowLandscapeMode: PropTypes.bool,
  serverAppTheme: PropTypes.object,
  seat: PropTypes.object,
  handleLoyaltyInfo: PropTypes.func,
  setLoyaltyType: PropTypes.func,
  setErrorPopUp: PropTypes.func,
  deviceInfo: PropTypes.object,
  checkAndSeats: PropTypes.object,
};

Loyalty.defaultProps = {
  loyaltyInfo: {},
  setPaymentFlowTypeLoyoltyBack: () => {},
  handleLoyaltyNotNow: () => {},
  handleLoyaltySignIn: () => {},
  loyaltyType: 1,
  loyaltyMethod: "",
  handleLoyaltySubmit: () => {},
  getLoyaltyOffers: () => {},
  loyaltyOffers: {},
  handleApplyOffer: () => {},
  joinMethod: "",
  openLoyaltyKeyboard: () => {},
  countryCode: "",
  handleBackButton: () => ({ url: () => {} }),
  groupedLoyaltyOffers: [],
  accountLookup: () => {},
  deleteLoyalty: () => {},
  handleCountryCodeChange: () => {},
  isConfirmStageSplit: false,
  suppressOfferOnSplitByPerson: false,
  ShowLandscapeMode: false,
  serverAppTheme: {},
  seat: {},
  handleLoyaltyInfo: () => {},
  setLoyaltyType: () => {},
  setErrorPopUp: () => {},
  deviceInfo: {},
  checkAndSeats: {},
};

export default React.memo(Loyalty);
